import { api, unwrap } from "./httpClient";

export interface Notification {
  id: number;
  userId: number;
  type: string;
  title: string;
  message: string;
  metadata: Record<string, any> | null;
  isRead: boolean;
  createdAt: string;
  readAt: string | null;
}

export const getNotifications = async (options?: {
  limit?: number;
  offset?: number;
  unreadOnly?: boolean;
}): Promise<Notification[]> => {
  const params: Record<string, string> = {};
  if (options?.limit) params.limit = options.limit.toString();
  if (options?.offset) params.offset = options.offset.toString();
  if (options?.unreadOnly) params.unreadOnly = "true";

  return unwrap(
    api<Notification[]>({
      method: "GET",
      url: "/notifications",
      params,
    })
  );
};

export const getUnreadCount = async (): Promise<number> => {
  const data = await unwrap(
    api<{ count: number }>({
      method: "GET",
      url: "/notifications/unread-count",
    })
  );
  return data.count;
};

export const markAsRead = async (notificationId: number): Promise<void> => {
  await unwrap(
    api({
      method: "PATCH",
      url: `/notifications/${notificationId}/read`,
    })
  );
};

export const markAllAsRead = async (): Promise<void> => {
  await unwrap(
    api({
      method: "PATCH",
      url: "/notifications/read-all",
    })
  );
};

export const deleteNotification = async (
  notificationId: number
): Promise<void> => {
  await unwrap(
    api({
      method: "DELETE",
      url: `/notifications/${notificationId}`,
    })
  );
};
